export enum RESET_STATE {
    DELETE_AND_START_OVER = 'deleteAndStartOver',
    LEAVE_AND_DISCARD = 'leaveAndDiscard',
    ABANDON_AND_CREATE = 'abandonAndCreate'
}
